import React from 'react';
import { ArrowLeft, Lock } from 'lucide-react';

const PrivacyPolicy = ({ onBack }) => {
    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
            <nav className="fixed w-full bg-white/80 backdrop-blur-md z-50 border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                    <button
                        onClick={onBack}
                        className="flex items-center gap-2 text-slate-600 hover:text-blue-600 transition-colors font-medium"
                    >
                        <ArrowLeft size={20} />
                        Back to Home
                    </button>
                    <div className="flex items-center gap-2">
                        <Lock className="text-blue-600" size={24} />
                        <span className="font-bold text-xl tracking-tight text-slate-900">Privacy Policy</span>
                    </div>
                </div>
            </nav>

            <main className="pt-32 pb-20 max-w-4xl mx-auto px-6">
                <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200 prose prose-slate max-w-none">
                    <h1 className="text-3xl font-bold mb-8 text-slate-900">Privacy Policy</h1>
                    <p className="text-slate-500 mb-8">Last Updated: December 2025</p>

                    <h2>1. Introduction</h2>
                    <p>
                        Resume Architect ("we", "our", or "us") respects your privacy and is committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and use our services.
                    </p>

                    <h2>2. Information We Collect</h2>
                    <p>
                        We may collect, use, store and transfer different kinds of personal data about you which we have grouped together follows:
                    </p>
                    <ul>
                        <li><strong>Identity Data:</strong> First name, last name, username or similar identifier.</li>
                        <li><strong>Contact Data:</strong> Email address.</li>
                        <li><strong>Resume Data:</strong> Professional history, education, skills, and other information you enter into the builder.</li>
                        <li><strong>Usage Data:</strong> Information about how you use our website and services.</li>
                    </ul>

                    <h2>3. How We Use Your Personal Data</h2>
                    <p>
                        We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                    </p>
                    <ul>
                        <li>To provide and maintain our Service.</li>
                        <li>To allow you to participate in interactive features of our Service.</li>
                        <li>To provide customer support.</li>
                        <li>To gather analysis or valuable information so that we can improve our Service.</li>
                        <li>To detect, prevent and address technical issues.</li>
                    </ul>

                    <h2>4. Data Security</h2>
                    <p>
                        We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.
                    </p>

                    <h2>5. Third-Party Services</h2>
                    <p>
                        We may employ third-party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                    </p>
                    <p>
                        Specifically, we use Firebase (by Google) for authentication and data storage. Please refer to Google's Privacy Policy for more information.
                    </p>

                    <h2>6. Your Legal Rights</h2>
                    <p>
                        Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to request access, correction, erasure, restriction, transfer, to object to processing, to portability of data and (where the lawful ground of processing is consent) to withdraw consent.
                    </p>

                    <h2>7. Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please contact us at <a href="mailto:resume.architect.pro.help@gmail.com" className="text-blue-600 hover:text-blue-800">resume.architect.pro.help@gmail.com</a>.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default PrivacyPolicy;
